module.exports = __webpack_public_path__ + "img/Solanum_lycopersicum.3377c411.jpg";